import { useMutation } from "@apollo/react-hooks";

import { Learner, MutationUpdateLearnerArgs } from "@hubcapp/types";

import mutationUpdateLearner from "../graph-ql/mutationUpdateLearner.graphql";

const useMutationUpdateLearner = () =>
  useMutation<{ learner: Learner }, MutationUpdateLearnerArgs>(
    mutationUpdateLearner,
  );

export default useMutationUpdateLearner;
